import { render, staticRenderFns } from "./dataCenter.vue?vue&type=template&id=8759394a&scoped=true"
import script from "./dataCenter.vue?vue&type=script&lang=js"
export * from "./dataCenter.vue?vue&type=script&lang=js"
import style0 from "./dataCenter.vue?vue&type=style&index=0&id=8759394a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8759394a",
  null
  
)

export default component.exports